<template>
  <div>
    <b-modal id="edit-element-modal" :title="title" :size="size" centered>
      <input
        type="text"
        class="form-control mt-3"
        v-model.trim="$v.elementValue.$model"
      />

      <template #modal-footer>
        <div class="w-100">
          <LoadingButton
            :text="'Modifica'"
            :classes="['btn-primary', 'w-100']"
            :disabled="$v.$invalid"
            @click="edit()"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  props: ["title", "size", "element", "elementName"],
  data() {
    return {
      elementValue: "",
    };
  },
  validations: {
    elementValue: {
      required,
    },
  },
  watch: {
    element: function (newElement) {
      this.elementValue = newElement[this.elementName];
    },
  },
  methods: {
    edit() {
      this.element[this.elementName] = this.elementValue;

      this.$emit("edit", this.element);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/EditElementDialog.vue